<template>
  <div class="container">
    <div class="toolbox">
      <ul>
        <li @click="addItem(1)">
          <i class="el-icon-edit custom-size" />
        </li>
        <li @click="addItem(2)">
          <i class="el-icon-document custom-size" />
        </li>
        <!-- <li @click="addItem(3)">
          <i class="el-icon-mic custom-size" />
        </li> -->
        <li @click="addItem(4)">
          <i class="el-icon-video-play custom-size" />
        </li>
        <!-- <li @click="addItem(5)">
          <i class="el-icon-notebook-2 custom-size" />
        </li> -->
      </ul>
    </div>
    <div v-for="(lesson, index) in lessonItens" :key="index" class="lesson">
      <vue-editor
        v-if="lesson.type === '1'"
        v-model="lesson.content"
        class="container__lesson text"
      />
      <el-upload
        v-if="lesson.type === '2'"
        class="upload-demo container__lesson"
        drag
        action="https://jsonplaceholder.typicode.com/posts/"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :file-list="fileList"
        multiple
        accept=""
      >
        <i class="el-icon-upload" />
        <div class="el-upload__text">
          Arraste seu arquivo PDF ou <em>clique em buscar</em>
        </div>
      </el-upload>
      <el-upload
        v-if="lesson.type === '3'"
        class="upload-demo container__lesson"
        drag
        action="https://jsonplaceholder.typicode.com/posts/"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :file-list="fileList"
        multiple
      >
        <i class="el-icon-upload" />
        <div class="el-upload__text">
          Arraste seu arquivo de áudio aqui ou <em>clique para buscar</em>
        </div>
      </el-upload>
      <div v-if="lesson.type === '4'" class="container__video">
        <input
          class="container__video-input"
          type="text"
          placeholder="Youtube Video Link or Video Id"
          :value="lesson.content"
          @change="handleSearch($event, 'youtube', index)"
        />

        <LazyYoutube
          v-if="lesson.content.length > 0"
          ref="youtubeLazyVideo"
          :src="lesson.content"
          max-width="720px"
          aspect-ratio="16:9"
          thumbnail-quality="standard"
        />
      </div>
      <div v-if="lesson.type === 5" class="container__lesson quiz">
        <el-input
          v-model="enunciado"
          placeholder="Enunciado"
          class="question"
        />

        <div class="answer__container">
          <el-switch v-model="value1" />
          <el-input
            v-model="questionArray[position].a1"
            placeholder="Opção 1"
          />
        </div>

        <div class="answer__container">
          <el-switch v-model="value2" />
          <el-input
            v-model="questionArray[position].a2"
            placeholder="Opção 2"
          />
        </div>

        <div class="answer__container">
          <el-switch v-model="value3" />
          <el-input
            v-model="questionArray[position].a3"
            placeholder="Opção 3"
          />
        </div>

        <div class="answer__container">
          <el-switch v-model="value4" />
          <el-input
            v-model="questionArray[position].a4"
            placeholder="Opção 4"
          />
        </div>

        <div class="answer__container">
          <el-switch v-model="value5" />
          <el-input
            v-model="questionArray[position].a5"
            placeholder="Opção 5"
          />
          <el-switch
            v-model="questionArray[position].value1"
            active-text="Correto"
          />
          <br />
          <el-button
            v-if="position !== 0"
            style="margin-top: 20px"
            @click="previous"
          >
            Anterior
          </el-button>
          <el-button style="margin-top: 20px" @click="next">
            Proximo
          </el-button>
        </div>
      </div>
    </div>
    <el-button style="margin-top: 20px" @click="finish"> Finalizar </el-button>
    <div style="display: none">
      <!-- {{ getLessons($route.params.id) }} -->
    </div>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor';
import { LazyYoutube } from 'vue-lazytube';

import axios from 'axios';

export default {
  components: {
    VueEditor,
    LazyYoutube,
  },
  data() {
    return {
      youtubeLink: '',
      position: 0,
      lessonArray: [],
      lessonItens: null,
      content: 'rsrs',
      questionArray: [
        {
          enunciado: '',
          a1: '',
          a2: '',
          a3: '',
          a4: '',
          a5: '',
          value1: false,
          value2: false,
          value3: false,
          value4: false,
          value5: false,
        },
      ],
    };
  },
  async created() {
    await this.getLessons();
  },

  methods: {
    async getLessons() {
      // const lessonId = this.$route;
      const response = await axios.get(
        process.env.VUE_APP_API + `/lessons/${this.$route.params.id}`
      );
      this.lessonItens = response.data.lessonItens;
      return response.data;
    },
    handleClick(event, ref) {
      this.$refs[ref][event]();
    },
    handleSearch(e, platform, index) {
      console.log(index);
      this.lessonItens[index].content = e.target.value;
      if (platform === 'youtube') this.youtubeLink = e.target.value;
      else this.vimeoLink = e.target.value;
    },
    addItem(type) {
      console.log(this.lessonItens);
      this.lessonItens.push({
        type: type.toString(),
        content: '',
      });
    },
    onResult(data) {
      console.log('The blob data:', data);
      console.log('Downloadable audio', window.URL.createObjectURL(data));
    },

    async finish() {
      this.lessonItens.forEach(async (item) => {
        if (item.id) {
          await axios.patch(
            process.env.VUE_APP_API + '/lesson-item/' + item.id,
            item
          );
        } else {
          const lessonItem = {
            type: item.type,
            content: item.content,
            lessonId: this.$route.params.id,
          };
          await axios.post(
            process.env.VUE_APP_API + '/lesson-item/',
            lessonItem
          );
        }
      });
      this.$router.push({ path: '/teacher/courses' });
    },

    next() {
      this.questionArray.push({
        enunciado: '',
        a1: '',
        a2: '',
        a3: '',
        a4: '',
        a5: '',
        value1: false,
        value2: false,
        value3: false,
        value4: false,
        value5: false,
      });
      this.position = +1;
    },
  },
};
</script>

<style lang="scss">
.container {
  width: 80%;
  .container__video {
    display: flex;
    flex-direction: column;
    align-items: center;

    .container__video-input {
      width: 50%;
      border: 1px solid rgba(0, 0, 0, 0.32);
      font-size: 14px;
      color: #000;
      padding: 10px;
      border-radius: 4px;
      margin: 8px 0;
    }
  }
  .toolbox {
    position: fixed;
    top: 40px;
    transition: top 1.3s;
    margin: 50px;
    background-color: white;
    right: 5vw;
    border-radius: 20px;
    z-index: 100;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      overflow: hidden;
    }

    li {
      padding: 20px;
      cursor: pointer;
      &:hover {
        background-color: lightgray;
        border-radius: 20px;
      }
      .custom-size {
        font-size: 2.5rem;
      }
    }
  }

  .lesson {
    width: 100%;

    .container__lesson {
      background: white;
      margin: 20px;
      border-radius: 20px;
      padding: 20px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
        0 6px 20px 0 rgba(0, 0, 0, 0.19);
      display: flex;
      justify-content: center;

      &.text {
        overflow: hidden;
        padding: 0;
        display: block;

        .ql-container.ql-snow {
          border: 0px solid #ccc;
        }
      }

      &.quiz {
        display: block;

        .question {
          margin-bottom: 20px;
        }

        .answer__container {
          display: flex;
          align-items: center;
          gap: 20px;
          padding: 10px 0;
        }
      }
    }
  }
}
</style>